import React, { useEffect, useRef } from "react";
import "./IntroSection.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const IntroSection: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const questionRef = useRef<HTMLHeadingElement>(null);
  const descriptionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // 初期状態を確実に設定
    gsap.set([questionRef.current, descriptionRef.current], {
      opacity: 1,
      y: 0,
    });

    gsap.fromTo(
      questionRef.current,
      { opacity: 0, y: 50 },
      {
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 80%",
          toggleActions: "play none none none",
          once: true,
        },
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power3.out",
      },
    );

    gsap.fromTo(
      descriptionRef.current,
      { opacity: 0, y: 50 },
      {
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 70%",
          toggleActions: "play none none none",
          once: true,
        },
        opacity: 1,
        y: 0,
        duration: 1,
        delay: 0.3,
        ease: "power3.out",
      },
    );
  }, []);

  return (
    <section
      className="intro-section"
      ref={sectionRef}
      aria-label="eComicシリーズ紹介"
    >
      <div className="intro-container">
        <h2 ref={questionRef} className="intro-question">
          本当にキレイな電子コミックって
          <br />
          みたことありますか？
        </h2>
        <div ref={descriptionRef} className="intro-description">
          <p className="intro-text">
            まんがにこだわる共同印刷ならではの、
            <br />
            高品質な電子コミック制作ソリューションが
            <br />
            <strong>『eComicシリーズ』</strong>です。
          </p>
          <p className="intro-closing">
            ３つの技術でこれまでの電子コミックの常識を変えます。
          </p>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
